import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { CalendarCheck, Users, LogOut, Phone } from "lucide-react";
import { Logo } from "../../components/Shared";
import { useAuth } from "../../context/AuthContext";

export default function CMLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-sand pb-20" data-testid="cm-portal">
      <header className="sticky top-0 z-40 border-b border-stone-200 bg-emerald-950 text-white">
        <div className="mx-auto flex h-14 max-w-lg items-center justify-between px-4">
          <Logo light />
          <div className="flex items-center gap-2">
            <span className="text-xs text-emerald-200">{user?.name}</span>
            <button onClick={() => { logout(); navigate("/"); }} className="rounded-full p-2 text-emerald-200 hover:bg-white/10" aria-label="Log out" data-testid="cm-logout"><LogOut className="h-4 w-4" /></button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-lg px-4 py-5"><Outlet /></main>
      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-200 bg-white" data-testid="cm-bottom-nav">
        <div className="mx-auto flex max-w-lg justify-around py-2">
          <NavLink to="/app/cm" end className={({ isActive }) => `flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] font-semibold ${isActive ? "text-emerald-900" : "text-stone-400"}`} data-testid="cm-nav-today">
            <CalendarCheck className="h-5 w-5" /> Today
          </NavLink>
          <NavLink to="/app/cm#families" className="flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] font-semibold text-stone-400" data-testid="cm-nav-families">
            <Users className="h-5 w-5" /> Families
          </NavLink>
          <NavLink to="/app/cm/profile" className={({ isActive }) => `flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] font-semibold ${isActive ? "text-emerald-900" : "text-stone-400"}`} data-testid="cm-nav-profile">
            <Phone className="h-5 w-5" /> Alerts
          </NavLink>
        </div>
      </nav>
    </div>
  );
}
